import { Platform } from 'react-native';

let db: any = null;

export const initDatabase = async () => {
  if (Platform.OS !== 'web') {
    const SQLite = require('expo-sqlite');
    db = await SQLite.openDatabaseAsync('db.db');
  }
};

export const getDb = () => {
  if (!db) {
    throw new Error('Database not initialized. Call initDatabase() first.');
  }
  return db;
};
